var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4501 64.4584H19.5501C8.47175 64.4584 3.54175 59.5284 3.54175 48.4501V36.5501C3.54175 25.4717 8.47175 20.5417 19.5501 20.5417H31.4501C42.5284 20.5417 47.4584 25.4717 47.4584 36.5501V48.4501C47.4584 59.5284 42.5284 64.4584 31.4501 64.4584ZM19.5501 24.7917C10.7667 24.7917 7.79175 27.7667 7.79175 36.5501V48.4501C7.79175 57.2334 10.7667 60.2084 19.5501 60.2084H31.4501C40.2334 60.2084 43.2084 57.2334 43.2084 48.4501V36.5501C43.2084 27.7667 40.2334 24.7917 31.4501 24.7917H19.5501Z",
    fill: "#5F5F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4501 47.4584H45.3334C44.1717 47.4584 43.2084 46.4951 43.2084 45.3334V36.5501C43.2084 27.7667 40.2334 24.7917 31.4501 24.7917H22.6667C21.5051 24.7917 20.5417 23.8284 20.5417 22.6667V19.5501C20.5417 8.47175 25.4717 3.54175 36.5501 3.54175H48.4501C59.5284 3.54175 64.4584 8.47175 64.4584 19.5501V31.4501C64.4584 42.5284 59.5284 47.4584 48.4501 47.4584ZM47.4584 43.2084H48.4501C57.2334 43.2084 60.2084 40.2334 60.2084 31.4501V19.5501C60.2084 10.7667 57.2334 7.79175 48.4501 7.79175H36.5501C27.7667 7.79175 24.7917 10.7667 24.7917 19.5501V20.5417H31.4501C42.5284 20.5417 47.4584 25.4717 47.4584 36.5501V43.2084Z",
    fill: "#5F5F5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.8c81615e1da1b4eb267330814751e3d6.svg";
export { ForwardRef as ReactComponent };